// extracted by mini-css-extract-plugin
export default {"helpHeader":"TermsAndCondition_helpHeader__Sg++t","contentWrapper":"TermsAndCondition_contentWrapper__iZ94+","detail":"TermsAndCondition_detail__whNAK"};